import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  costmapping_id: '',
  costmapping_date: '',
  costmapping_description: '',
  costmapping_isposted: 0,
  reference_id: '',
  costmapping_type: '',
  costmapping_createdby: '',
  costmapping_createddate: '',
  costmapping_modifyby: '',
  costmapping_modifydate: '',
  rowid: '',
  detail: [],
  log: [],
  tabs: {
    detail: 'Detail',
    log: 'Log',
    record: 'Record',
  },
};

const initialState = {
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  loadingMessage: '',
  error: null,
  activeTab: 0,
  detailTab: 0,
  selectedDetailId: null,
};

const fin07costmappingSlice = createSlice({
  name: 'fin07costmapping',
  initialState,
  reducers: {
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    setDetailTab: (state, action) => { state.detailTab = action.payload; },
    setSelectedDetailId: (state, action) => { state.selectedDetailId = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    clearFormData: (state) => {
      state.formData = initialFormData;
      state.detailTab = 0;
      state.selectedDetailId = null;
    },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialFormData, ...action.payload };
      state.loading = false;
      state.error = null;
      state.selectedDetailId = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearModuleState: (state) => {
      state.formData = initialFormData;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.activeTab = 0;
      state.detailTab = 0;
      state.selectedDetailId = null;
    },
  },
});

export const {
  setActiveTab,
  setDetailTab,
  setSelectedDetailId,
  setDataList,
  setTotalData,
  setLoading,
  setLoadingMessage,
  setErrorMsg,
  updateFormData,
  clearFormData,
  fetchDetailSuccess,
  fetchDetailFailure,
  clearModuleState,
} = fin07costmappingSlice.actions;

export default fin07costmappingSlice.reducer;
